import client from './client';

/** Актёр из Кинопоиска. Имени роли у него НЕТ — поле роли в источнике пустое
 *  у всех фильмов проката, поэтому в интерфейсе только фото и имя. */
export interface CinemaActor {
  name: string;
  photo: string;
}

/** Сеанс с залом и признаком 3D. `hall` — ПОРЯДКОВЫЙ номер (1…4), а не
 *  внутренний id виджета кинотеатра. */
export interface CinemaSession {
  time: string;
  hall: number | null;
  is3d: boolean;
}

export interface CinemaMovie {
  id: number;
  title: string;
  poster_url: string | null;
  rating: number | null;
  description: string | null;
  trailer_url: string | null;
  tags: string[];
  sessions: string[];
  show_date: string | null;
  sort_order: number;
  is_active: boolean;
  updated_at: string | null;
  // ── Карточка фильма (30.07.2026) ──────────────────────────────────────
  // Тянется из Кинопоиска при «Обновить из источника». Редактор видит эти
  // поля, чтобы понимать, что уехало в приложение.
  actors: CinemaActor[];
  director: string | null;
  /** Минуты. */
  movie_length: number | null;
  /** 0/6/12/16/18. */
  age_rating: number | null;
  backdrop_url: string | null;
  short_description: string | null;
  genres: string[];
  countries: string[];
  release_year: number | null;
  sessions_detail: CinemaSession[];
}

export interface CinemaMoviePayload {
  title: string;
  poster_url?: string | null;
  rating?: number | null;
  description?: string | null;
  trailer_url?: string | null;
  tags?: string[];
  sessions?: string[];
  show_date?: string | null;
  sort_order?: number;
  is_active?: boolean;
  director?: string | null;
  movie_length?: number | null;
  age_rating?: number | null;
}

export const cinemaApi = {
  list: () => client.get<CinemaMovie[]>('/api/admin/cinema'),

  create: (data: CinemaMoviePayload) =>
    client.post<CinemaMovie>('/api/admin/cinema', data),

  update: (id: number, data: Partial<CinemaMoviePayload>) =>
    client.patch<CinemaMovie>(`/api/admin/cinema/${id}`, data),

  delete: (id: number) => client.delete(`/api/admin/cinema/${id}`),

  bulkUpsert: (movies: CinemaMoviePayload[]) =>
    client.post<CinemaMovie[]>('/api/admin/cinema/bulk-upsert', { movies }),

  refresh: () =>
    client.post<{
      result: { created?: number; updated?: number; deleted?: number };
      movies: CinemaMovie[];
    }>('/api/admin/cinema/refresh'),
};
